module.exports = __webpack_public_path__ + "img/scope.0da11b40.svg";